import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';

const HeaderElement = styled.header`
  position: relative;
  display: flex;
  width: 100%;
  min-height: ${(props) =>
    props.$minimized ? '150px' : props.$minHeight ?? '600px'};

  @media (min-width: 377px) and (max-width: 768px) {
    background-size: 600px;
    background-position: ${(props) =>
      props.$minimized || props.$minHeight
        ? 'top -100px right 10%;'
        : 'top 80px right 20%'};
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    background-size: 700px;
    background-position: ${(props) =>
      props.$minimized || props.$minHeight
        ? 'top -100px right 10%;'
        : 'top 50px right 40%'};
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background: white;
    background-image: radial-gradient(
        at 9.3% 2.6%,
        #0097ff 0px,
        transparent 50%
      ),
      radial-gradient(at 85.8% 22.6%, #2ed3b7 0px, transparent 50%),
      radial-gradient(at -0.2% 44.3%, hsl(204, 100%, 50%) 0px, transparent 50%),
      radial-gradient(at 64.5% 55.3%, hsl(170, 65%, 50%) 0px, transparent 50%),
      radial-gradient(at 77% 78.1%, hsl(170, 65%, 50%) 0px, transparent 50%),
      radial-gradient(at 26.4% 79.5%, hsl(170, 65%, 50%) 0px, transparent 50%),
      radial-gradient(at 60% 30.5%, hsl(204, 100%, 50%) 0px, transparent 50%),
      radial-gradient(at 33% 40.9%, hsl(204, 100%, 50%) 0px, transparent 50%),
      radial-gradient(at 51.3% 18.8%, hsl(204, 100%, 50%) 0px, transparent 50%);
    background-position: center;
    background-size: auto;
    border-radius: ${(props) =>
      props.$curved ? '0 0 50% 50%/0 0 100% 100%' : '0'};
    transform: scaleX(1.9);

    @media (max-width: 1024px) {
      transform: scaleX(2.6);
    }
  }

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url('/icons/logo.svg');
    background-repeat: no-repeat;
    background-position: ${(props) =>
      props.$minimized ? 'top -100px right 40%;' : 'top -20px right 40%;'};
    background-size: 800px;
    border-radius: 0 0 50% 50%/0 0 100% 100%;
    transform: scale(1.9);
    z-index: 0;

    @media (max-width: 376px) {
      background-size: ${(props) =>
        props.$minimized || props.$minHeight ? '400px' : '600px'};
      background-position: ${(props) =>
        props.$minimized ? 'top -50px right 40%;' : 'top 50px right -100px'};
    }
  }
`;

const BackgroundFadeElement = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  background-image: linear-gradient(to bottom, transparent, #eff6ff);
`;

const HeaderBackground = ({
  minHeight,
  minimized,
  curved = true,
  fade = false,
  children,
}) => (
  <HeaderElement $minHeight={minHeight} $minimized={minimized} $curved={curved}>
    <div
      className={cx(
        'flex flex-1 flex-col md:flex-row gap-8 mx-auto px-8 max-w-7xl justify-between z-10',
        {
          'py-10 pt-20 md:pt-12': !fade,
          'pt-20 pb-60': fade,
        }
      )}
    >
      {children}
    </div>
    {fade && <BackgroundFadeElement />}
  </HeaderElement>
);

export default HeaderBackground;
